import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Abdirashid Kheyre </span>
            from <span className="purple"> Mogadishu, Somalia.</span>
            <br /> I am a final year student of Bachelor's degree
            in Computer Applicaiton.
            <br />
            Additionally, I am currently employed as a software developer at
            Yooltech.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Foodball
            </li>
            <li className="about-activity">
              <ImPointRight /> Watching Action Movies
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "The best way to learn new thing is to do it, just do it!"{" "}
          </p>
          <footer className="blockquote-footer">Abdirashid Kherye</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
